import moment from 'moment';

import {
  LeadCallOutcome,
  LeadFollowUpReason,
  LeadHistoryType,
  LeadLostReason,
} from '../../../../Model/Lead';

const EMPTY_VALUE = '';
const MAX_CALL_ATTEMPTS = 2;

const CallType = {
  RANG: 'RANG',
  VOICEMAIL: 'VOICEMAIL',
};

const CallTypeLabel = {
  [CallType.RANG]: 'Rang',
  [CallType.VOICEMAIL]: 'Voicemail',
};

const DefaultReason = {
  [LeadCallOutcome.LOST]: LeadLostReason.AFFORDABILITY,
  [LeadCallOutcome.FOLLOW_UP]: LeadFollowUpReason.TIME_TO_THINK,
};

const getCreatedAtTimestamp = (record) => {
  if (!record?.createdAt || typeof record.createdAt.toDate !== 'function') {
    return 0;
  }

  return moment(record.createdAt.toDate()).valueOf();
};

const getOutcomeRecord = (record) => {
  const { outcome = EMPTY_VALUE, attemptType = EMPTY_VALUE } = record?.value || {};

  return {
    outcome,
    attemptType,
  };
};

const getRecentConsecutiveNotAnsweredAttempts = (outcomeHistoryRecords = []) => {
  const outcomeRecords = outcomeHistoryRecords.map((historyRecord) => ({
    ...getOutcomeRecord(historyRecord),
    createdAt: historyRecord.createdAt,
    createdBy: historyRecord.createdBy || historyRecord.id,
  }));

  const firstNonNotAnsweredIndex = outcomeRecords.findIndex(
    (record) => record.outcome !== LeadCallOutcome.NOT_ANSWERED,
  );
  const consecutiveNotAnswered = (
    firstNonNotAnsweredIndex === -1
      ? outcomeRecords
      : outcomeRecords.slice(0, firstNonNotAnsweredIndex)
  ).slice(0, MAX_CALL_ATTEMPTS);

  return consecutiveNotAnswered.reverse().map((attempt, index) => ({
    ...attempt,
    attemptCount: index + 1,
  }));
};

const getSortedCallOutcomeHistoryRecords = (historyRecords = []) => historyRecords
  .filter((history) => history.activityType === LeadHistoryType.CALL_OUTCOME)
  .sort((a, b) => getCreatedAtTimestamp(b) - getCreatedAtTimestamp(a));

const hasSentToRescheduleHistoryRecord = (historyRecords = []) => historyRecords
  .some((history) => history.activityType === LeadHistoryType.SENT_TO_RESCHEDULE);

/*
  The intent flag is captured before the automated Won transition on both close paths:
  at the deferred close (Follow Up with the contract-created reason) and within the Won
  event before the modal dismisses (immediate path). Payment Pending is a later touch on
  the deferred path, where the flag stays editable until the lead reaches Won.
*/
const isIntentFlagApplicable = (leadCallOutcome, reason) => (
  leadCallOutcome === LeadCallOutcome.WON
  || leadCallOutcome === LeadCallOutcome.PAYMENT_PENDING
  || (
    leadCallOutcome === LeadCallOutcome.FOLLOW_UP
    && reason === LeadFollowUpReason.CONTRACT_CREATED_PENDING_ONBOARDING
  )
);

export {
  CallType,
  CallTypeLabel,
  DefaultReason,
  EMPTY_VALUE,
  MAX_CALL_ATTEMPTS,
  getCreatedAtTimestamp,
  getRecentConsecutiveNotAnsweredAttempts,
  getSortedCallOutcomeHistoryRecords,
  hasSentToRescheduleHistoryRecord,
  isIntentFlagApplicable,
};
